// Copyright ©️ 2026 eVolve MEP, LLC

import { type FacilityId, useEvolveDelete } from '@evolvemep/api-ts';
import { notifications } from '@mantine/notifications';

import type { ModalRegistryManagedProps } from 'components/Mantine/Modals/createModalRegistry';
import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';

type Props = ModalRegistryManagedProps & {
  facilityId: FacilityId;
  onDraftDiscarded: () => Promise<void>;
};

export const DiscardDraftChangesModal = ({ facilityId, onDraftDiscarded, ...props }: Props) => {
  const { apiCall: deleteDraftShopConfigurationApiCall } = useEvolveDelete(`shop/configuration/${facilityId}/draft`);
  return (
    <WrappedModal
      title="Discard changes"
      confirmationText="Discard"
      buttonColor="red"
      onConfirm={async () => {
        await deleteDraftShopConfigurationApiCall();
        await onDraftDiscarded();
        notifications.show({
          title: 'Successfully discarded changes',
          message: 'Work Cell Setup changes discarded.',
          color: 'green',
        });
      }}
      {...props}
    >
      Are you sure you want to discard your changes?
    </WrappedModal>
  );
};
